import { Layout } from '@/components/generic';

import Description from './Description';
import Header from './Header';

export const Terms = () => {
  return (
    <div className='min-h-screen bg-b-surface1 font-inter text-body-1 text-t-primary antialiased'>
      <Layout title='Terms'>
        <div className='card px-12 py-22 max-lg:p-8 max-lg:px-6'>
          <div className='max-w-215 mx-auto'>
            <Header />
          </div>
        </div>
        <Description />
      </Layout>
    </div>
  );
};
